var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMegaphoneinline = function SvgMegaphoneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7v7a3.5 3.5 0 0 0 0-7M11.896 18.382h-5.77c-.08 0-.157-.01-.235-.012l3.21 7.893a2.776 2.776 0 0 0 3.602 1.536 2.777 2.777 0 0 0 1.534-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.247.09a.88.88 0 0 0-.931.12c-.05.042-5.063 4.173-9.065 4.173H6.125A6.13 6.13 0 0 0 0 10.507a6.13 6.13 0 0 0 6.125 6.125h6.125c4.002 0 9.015 4.13 9.065 4.173a.876.876 0 0 0 1.435-.673V.882a.88.88 0 0 0-.503-.792"
  }))));
};
export default SvgMegaphoneinline;